import { useState } from "react";
import { Check, Copy, MessageSquareText, X } from "lucide-react";
import { dismissSmsNotice, useSmsNotices, type SmsNoticeItem } from "../lib/sms-notice";

function Card({ item }: { item: SmsNoticeItem }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="sms-notice" role="status">
      <div className="sms-notice-head">
        <MessageSquareText size={15} />
        <b>پیامک سندباکس</b>
        <button type="button" aria-label="بستن" onClick={() => dismissSmsNotice(item.id)}>
          <X size={14} />
        </button>
      </div>
      <div className="sms-notice-to">
        ارسال نشد؛ به‌جای پیامک به <bdi dir="ltr">{item.phone}</bdi> اینجا نشان داده می‌شود.
      </div>
      <div className="sms-notice-to"><b>سندباکس: کد ورود هر شماره به هر کسی نشان داده می‌شود؛ اطلاعات واقعی افراد را اینجا وارد نکنید.</b></div>
      {item.code ? (
        <div className="sms-notice-code">
          <bdi dir="ltr">{item.code}</bdi>
          <button
            type="button"
            onClick={() => {
              void navigator.clipboard?.writeText(item.code!).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
              });
            }}
          >
            {copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "کپی شد" : "کپی کد"}
          </button>
        </div>
      ) : null}
      <div className="sms-notice-text">{item.message}</div>
    </div>
  );
}

/** Sandbox only: SMS shown at the top of the screen instead of sent, until closed. */
export function SmsNotice() {
  const list = useSmsNotices();
  if (!list.length) return null;
  return (
    <div className="sms-notices" dir="rtl" aria-live="polite">
      {list.map((s) => (
        <Card key={s.id} item={s} />
      ))}
    </div>
  );
}
